import React, { FC } from 'react'
import { classes } from 'typestyle'

import { ComponentBaselineType, ComponentProps } from '../__core/component.types'
import { withComponent } from '../__core/component'

import { headingClass } from './heading.class'

type HeadingComponentProps = {
  alt?: boolean
  baseline?: ComponentBaselineType
  children?: any
  className?: string
  tag?: any

  semiBold?: boolean
  bold?: boolean
  italic?: boolean
  link?: boolean
  uppercase?: boolean
} & ComponentProps

const defaultProps: {
  baseline?: ComponentBaselineType
  tag?: JSX.Element
} = {
  baseline: 'none',
  tag: <span />,
}

export const HeadingComponent: FC<HeadingComponentProps> = props => {
  const {
    alt,
    baseline,
    className,
    children,
    tag,
    bold,
    italic,
    link,
    semiBold,
    uppercase,
    size,
  } = props

  const {
    base,
    baseThemed,
    baseSemiBold,
    baseBold,
    baseItalic,
    baseLink,
    baseUppercase,
    baseSized,
  } = headingClass.setProps({ alt, baseline })

  return React.cloneElement(tag, {
    className: classes(
      className,
      base,
      baseThemed,
      // baseSized[size || 'md'],
      semiBold && baseSemiBold,
      bold && baseBold,
      italic && baseItalic,
      link && baseLink,
      uppercase && baseUppercase,
    ),
    children,
    ...tag.props,
  })
}

HeadingComponent.defaultProps = defaultProps

export const Heading = withComponent(HeadingComponent)
